var mixin = {
    methods: {
      // p = 傳入的props
      // 優先使用jsonProps的資料
      // 有jsonProps 不能有其他props
      detectDevice (mobile, pad, screen) {
        if (window.matchMedia("(max-width: 767px)").matches) {
          return mobile
        } else if ( window.matchMedia("(min-width: 768px)").matches && window.matchMedia("(max-width: 1279.98px)").matches ) {
          return pad
        } else {
          return screen
        }
      }
    }
  }
  
  export default mixin
  